import { render } from "./QueryPotter.vue?vue&type=template&id=96834a66&scoped=true"
import script from "./QueryPotter.vue?vue&type=script&lang=js"
export * from "./QueryPotter.vue?vue&type=script&lang=js"

import "./QueryPotter.vue?vue&type=style&index=0&id=96834a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96834a66"]])

export default __exports__